const GameStates = {
    MAIN: 'MAIN',
    FREESPINS: 'FREESPINS',
    FREESPINS_SUPER: 'FREESPINS_SUPER',
    FREESPINS_MEGA: 'FREESPINS_MEGA',
    CASCADES: 'CASCADES_MAIN',
    CASCADES_FREESPINS: 'CASCADES_FREESPINS',
    CASCADES_SUPER_FREESPINS: 'CASCADES_SUPER_FREESPINS',
    RETRIGGERING: 'RETRIGGERING',

    isFreeSpins(state) { return state.includes('FREESPINS')},
    isCascade(state) { return state.includes('CASCADE')},
    isRespin(state) { return state.includes('RESPIN') || state.includes('RETRIGGERING')},
};

const FeatureStates = {
    ENTER: 'ENTER',
    ACTIVE: 'ACTIVE',
    EXIT: 'EXIT',
    INACTIVE: 'INACTIVE',
    REDEEM_POPUP: 'REDEEM'
}

export default {
    GameStates,
    FeatureStates
}
